import { normalizeDobForCompare, toDobApiValue, toDobDisplayValue } from './contactFields'
import { PHONE_VALIDATION_MESSAGE, isValidPhoneNumber, normalizePhoneNumber } from './phone'

const NUMERIC_FIELDS = ['latitude', 'longitude']
const GENERIC_DIFF_FIELDS = ['name', 'phone', 'email', 'address', 'street', 'ward', 'district', 'province', 'latitude', 'longitude', 'stage', 'notes', 'gender']

// Diffs `draft` against `original` for the given editable `fields`, validates phone/dob,
// and returns either an error to show the user or a patch ready for patchContact().
export function buildContactPatch({ original, draft, fields, t }) {
  const nextPhone = fields.includes('phone') ? normalizePhoneNumber(draft.phone) : undefined

  if (fields.includes('stage')) {
    const nextStage = (draft.stage ?? 'customer').trim()
    if (nextStage === 'customer' && !nextPhone) {
      return { patch: null, error: 'Phone is required for customer stage' }
    }
  }
  if (nextPhone && !isValidPhoneNumber(nextPhone)) {
    return { patch: null, error: PHONE_VALIDATION_MESSAGE }
  }

  const patch = {}
  for (const f of fields.filter(f => GENERIC_DIFF_FIELDS.includes(f))) {
    const current = f === 'phone'
      ? normalizePhoneNumber(original[f])
      : (original[f] ?? '').toString().trim()
    const next = f === 'phone'
      ? nextPhone
      : (draft[f] ?? '').trim()
    if (next !== current) {
      if (NUMERIC_FIELDS.includes(f)) {
        if (next !== '' && Number.isNaN(Number(next))) {
          return { patch: null, error: `${f} must be a number` }
        }
        patch[f] = next === '' ? null : Number(next)
      } else {
        patch[f] = next === '' ? null : next
      }
    }
  }

  if (fields.includes('dob')) {
    const nextDobDisplay = (draft.dob ?? '').trim()
    const currentDob = normalizeDobForCompare(original.dob)
    if (nextDobDisplay !== toDobDisplayValue(original.dob)) {
      if (!nextDobDisplay) {
        if (currentDob) patch.dob = null
      } else {
        const nextDobApi = toDobApiValue(nextDobDisplay)
        if (!nextDobApi) {
          return { patch: null, error: t?.('contacts.dobInvalid') || 'Invalid date of birth. Use DD/MM/YYYY.' }
        }
        if (nextDobApi !== currentDob) patch.dob = nextDobApi
      }
    }
  }

  return { patch, error: null }
}
